import { ReactNode } from "react";
import BrandLogoStrip from "./BrandLogoStrip";

type AuthStatusScreenProps = {
  title: string;
  description: string;
  children?: ReactNode;
};

export default function AuthStatusScreen({
  title,
  description,
  children,
}: AuthStatusScreenProps) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white px-8 py-10 text-center shadow-sm">
        <BrandLogoStrip />
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        <p className="mt-2 text-sm leading-relaxed text-gray-500">{description}</p>
        {children}
      </div>
    </div>
  );
}
